import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/ClinicianNavigation.css';

const ClinicianNavigation = ({ activeSection, onSectionChange }) => {
  const location = useLocation();
  
  const navItems = [
    { id: 'patients', label: 'Patients', icon: '👥' },
    { id: 'triage', label: 'Triage', icon: '🚨' },
    { id: 'surveys', label: 'Surveys', icon: '📋' },
    { id: 'education', label: 'Education', icon: '📚' },
    { id: 'reports', label: 'Reports', icon: '📊' },
    { id: 'account', label: 'Account', icon: '⚙️' }
  ];

  return (
    <nav className="clinician-navigation">
      <div className="clinician-nav-container">
        {navItems.map((item) => {
          const path = `/clinician/${item.id}`;
          
          return (
            <Link
              key={item.id}
              to={path}
              className={`clinician-nav-item ${activeSection === item.id ? 'clinician-active' : ''}`}
              onClick={() => onSectionChange && onSectionChange(item.id)}
            >
              <span className="clinician-nav-icon">{item.icon}</span>
              <span className="clinician-nav-label">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default ClinicianNavigation;
